import {Component, OnInit, Input} from '@angular/core';
import {NgbCollapseModule} from "@ng-bootstrap/ng-bootstrap";
import {ExpandCollapseStateService} from "../services/expand-collapse-state.service";

@Component({
  selector: 'app-expand-collapse-section',
  standalone: true,
  imports: [NgbCollapseModule],
  templateUrl: './expand-collapse-section.component.html',
  styleUrl: './expand-collapse-section.component.scss'
})
export class ExpandCollapseSectionComponent implements OnInit {
  @Input() sectionId: string = '';
  @Input() isOpen: boolean = true;
  
  constructor(protected expandCollapseStateService: ExpandCollapseStateService) {
  }
  
  ngOnInit() {
    this.expandCollapseStateService.isOpenMap[this.sectionId] = this.isOpen;   
  }
  
}
